module.exports = __webpack_public_path__ + "static/media/joyable3_preview.9cfdb24e.jpg";